import AdminReportGrid from './AdminReportGrid';
export default AdminReportGrid; 



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/AdminReportGrid/index.js